// Mock data pro VM Projekty & Stavby

export const companyInfo = {
  name: "VM Projekty & Stavby s.r.o.",
  tagline: "Zednické práce v Brně a okolí",
  description: "Specializujeme se na kompletní výstavbu rodinných domů a rekonstrukce.",
  email: "info@vmprojektyastavby.cz",
  phone: "+420 608 598 104",
  location: "Brno a okolí",
  address: "Nové sady 988/2, Staré Brno, 602 00 Brno",
  ico: "24045187",
  dic: "CZ24045187"
};

export const services = [
  {
    id: 1,
    title: "Realizace staveb a rekonstrukcí",
    icon: "Building2",
    items: [
      "Zednické práce při rekonstrukcích domů a bytů",
      "Realizace hrubých staveb",
      "Základové desky"
    ]
  },
  {
    id: 2,
    title: "Zednické a stavební práce",
    icon: "Hammer",
    items: [
      "Zednické práce",
      "Omítky, perlinka, štuk",
      "Sádrokartonářské práce",
      "Obklady a dlažby"
    ]
  },
  {
    id: 3,
    title: "Exteriérové práce",
    icon: "Home",
    items: [
      "Pokládka zámkové dlažby",
      "Stavba plotů",
      "Zateplení fasád"
    ]
  },
  {
    id: 4,
    title: "Demoliční a výkopové práce",
    icon: "HardHat",
    items: [
      "Demoliční práce",
      "Bourací práce",
      "Výkopové práce"
    ]
  }
];

export const whyUs = [
  {
    id: 1,
    title: "Kvalita a detail",
    description: "Pracujeme pečlivě s důrazem na kvalitu a detail",
    icon: "CheckCircle2"
  },
  {
    id: 2,
    title: "Lokální působnost",
    description: "Působíme v Brně a okolí",
    icon: "MapPin"
  },
  {
    id: 3,
    title: "Rychlé jednání",
    description: "Rychlé jednání a profesionální přístup",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Kalkulace zdarma",
    description: "Nezávazná kalkulace zdarma",
    icon: "Calculator"
  }
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_brno-rekonstrukce/artifacts/sdgtzjc8_ChatGPT%20Image%203.%20M%C3%A4rz%202026%2C%2007_10_48.png",
  construction: "https://images.pexels.com/photos/534220/pexels-photo-534220.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  equipment: "https://images.unsplash.com/photo-1683372101362-2efc3e75650e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxyZXNpZGVudGlhbCUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3NzIwODYwMDF8MA&ixlib=rb-4.1.0&q=85",
  house1: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxjb250ZW1wb3JhcnklMjBob3VzZXxlbnwwfHx8fDE3NzIwODc1NTB8MA&ixlib=rb-4.1.0&q=85",
  house2: "https://images.pexels.com/photos/17174767/pexels-photo-17174767.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  logo: "https://customer-assets.emergentagent.com/job_brno-rekonstrukce/artifacts/g50od4p5_logo-VMstavby.png"
};
